import React from "react";
import { useDataLoader, order, LoadingRegion, groupBy, formatDate } from "@optimed/react";
import { syncService } from "../api";
import { Panel, PanelBody, Badge } from "@optimed/react";
import { DoctorLabel } from "./DoctorLabel";
import { ValidationView } from "./ValidationView";
import { modelValidator } from "./modelValidator";
import { Identifier } from "./Identifier";

export function AppointmentsPanel() {
  const [schedules, loading] = useDataLoader(() => syncService.bookings());
  const mappedSchedules = order(
    schedules ?? [],
    x => !x.doctorMapping?.his,
    x => x.doctorMapping?.docplanner?.doctor?.name,
    x => x.doctorMapping?.docplanner?.doctor?.surname
  );
  return (
    <Panel>
      <PanelBody>
        <LoadingRegion promise={loading}>
          {mappedSchedules.map(schedule => {
            let bookingGroups = groupBy(schedule?.bookings?.filter(x => x.docplanner?.status !== "canceled") ?? [], x =>
              formatDate(x.docplanner?.startAt)
            );
            return (
              <div key={schedule.doctorMapping?.docplanner?.doctor?.id} className="mb-3">
                <DoctorLabel doctor={schedule.doctorMapping!} />
                <ValidationView validations={modelValidator.checkBookings(schedule)} />
                <div className="small">
                  <div hidden={bookingGroups && bookingGroups.length > 0}>Brak wizyt</div>
                  {bookingGroups.map(day => (
                    <div key={day.keyHash}>
                      <div>{day.key}</div>
                      {day.items.map(booking => (
                        <div key={booking.docplanner?.id}>
                          <Badge
                            type={booking.his ? "secondary" : "danger"}
                            text={formatDate(booking.docplanner?.startAt, "HH:mm")}
                          />
                          <span>
                            {" "}
                            {booking.docplanner?.patient?.name} {(booking.docplanner?.patient?.surname ?? "X")[0]}
                            {". "}
                            {booking.docplanner?.addressService?.name}{" "}
                            <Identifier value={booking.docplanner?.id} title="Znany Lekarz" />
                          </span>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </LoadingRegion>
      </PanelBody>
    </Panel>
  );
}
